module.exports = __webpack_public_path__ + "static/media/storage-showcase.1d153c2a.mov";